import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from "@tanstack/react-query";
import type {
  DeleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdData,
  DeleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdResponse,
  DeleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdError,
  Assignment,
} from "../../../client";
import { deleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdMutation } from "../../../client/@tanstack/react-query.gen";
import { getAssignmentsQueryKey } from "./get-assignments";

export const useDeleteAssignment = (
  organizationId: string,
  options?: UseMutationOptions<
    DeleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdResponse,
    DeleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdError,
    DeleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdData
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...deleteV1OrganizationsByOrganizationIdAssignmentsByAssignmentIdMutation(),
    onSuccess: (data, variables, context) => {
      queryClient.setQueryData(
        getAssignmentsQueryKey(variables.path.organizationID),
        (oldData: Assignment[] | undefined) => {
          if (!oldData) return [];
          return oldData.filter(
            (item) => item.id !== variables.path.assignmentID,
          );
        },
      );

      options?.onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      options?.onError?.(error, variables, context);
    },
    onSettled: (data, error, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: getAssignmentsQueryKey(variables.path.organizationID),
      });
      options?.onSettled?.(data, error, variables, context);
    },
    ...options,
  });
};
